import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao" */ './views/Home.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `global.manage`,
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `settings.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/${apiConstants.code}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-regulations" */ './views/regulation/RegulationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.regulations`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-regulations" */ './views/regulation/RegulationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.regulations.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-regulations" */ './views/regulation/RegulationDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'item'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.regulations.show.group`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-regulations" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`,
                }
            },
            {
                path: 'item/:id',
                name: `${apiConstants.code}.regulations.show.item`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosecgestao-regulations" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `regulations.titles`,
        }
    },
];

export default routes;